<template>
<section class="mb-4">
  <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark">
    <div class="container">
      <a class="navbar-brand" href="#" @click.prevent="move('/')">
        <img src="./assets/icon_chocomint.png" srcset="./assets/icon_chocomint.png 1x, ./assets/icon_chocomint@2x.png 2x, ./assets/icon_chocomint@3x.png 3x" :alt="labels[shared.lang].title">
        {{ labels[shared.lang].title }}
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav" v-if="shared.user">
          <li class="nav-item"><a class="nav-link" href="#" v-text="labels[shared.lang].add" @click.prevent="move('/add')"></a></li>
        </ul>
        <form class="form-inline ml-lg-3 mt-3 mb-3 mt-lg-0 mb-lg-0" @submit.prevent="sendSearch">
          <div class="input-group">
            <input class="form-control" type="search" :placeholder="labels[shared.lang].search_input" aria-label="Search" v-model.trim="keyword">
            <div class="input-group-append">
              <button class="btn btn-outline-light" type="submit" v-text="labels[shared.lang].search"></button>
            </div>
          </div>
        </form>
        <ul class="navbar-nav mr-auto ml-3">
          <li class="nav-item" :class="{active: shared.lang == 'ja'}"><a class="nav-link" href="#" @click.prevent="changeLanguage('ja')">日本語</a></li>
          <li class="nav-item" :class="{active: shared.lang == 'ko'}"><a class="nav-link" href="#" @click.prevent="changeLanguage('ko')">한국어</a></li>
        </ul>
        
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" v-if="!shared.user"><a class="nav-link" href="#" v-text="labels[shared.lang].login" @click.prevent="requestLogin"></a></li>
          <li class="nav-item dropdown" v-if="shared.user">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <!--<img :src="'/'+shared.user.profile_image_url" width="25" height="25" alt="" class="rounded-circle align-middle mr-2">--><span class="align-middle" v-text="shared.user.name"></span></a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="#" v-text="labels[shared.lang].logout" @click.prevent="logout"></a>
            </div>
          </li>
        </ul>
      </div>
      
    </div>
  </nav>

  <section class="container"><router-view /></section>
  
  <footer class="text-right">
    Created by <a href="https://twitter.com/purely_m" target="_blank" rel="noopener noreferrer">@purely_m</a>. Version 2.1.2
  </footer>
</section>
</template>

<script>
'use strict'
import axios from 'axios'
import { labels } from './label.js'
import { shared } from './state.js'
axios.defaults.withCredentials = true

export default {
  name: 'App',
  data() {
    return {
      labels: labels,
      shared: shared,
      
      keyword: '',
    }
  },
  created() {
    shared.initLanguage()
    this.checkLogin()
  },
  methods: {
    changeLanguage(lang) {
      shared.changeLanguage(lang)
      try { this.$forceUpdate() } catch(e) {}
    },
    
    checkLogin() {
      axios.post(`${shared.apiroot}twitter/checklogin`, {a9cJa2JHa1: true, tyqZQSj791: window.getCookie('5zJuw2ej8Y')}).then((resp)=> {
        if(resp.data && resp.data.WgIiJlr9ZS) {
          setCookie('5zJuw2ej8Y', resp.data.WgIiJlr9ZS, 365)
        } else {
          removeCookie('5zJuw2ej8Y')
        }
        if(resp.data && resp.data.account) shared.user = resp.data.account
      }).catch(()=>{ })
    },
    move(path) {
      this.$router.push(path)
      if(path === '/') this.$root.$emit('global-search-keyword', '')
    },
    requestLogin() {
      axios.get(`${shared.apiroot}twitter/login`).then((resp)=> {
        if(resp.data.url) document.location.href = resp.data.url
      }).catch(()=>{})
    },
    logout() {
      axios.get(`${shared.apiroot}twitter/logout`).then((resp)=> {
        shared.user = null
        removeCookie('5zJuw2ej8Y')
      }).catch(()=>{})
    },
    sendSearch() {
      let query = {}
      if(this.keyword) query.keyword = this.keyword
      this.keyword = ''
      this.$router.push({path: '/', query: query})
      this.$root.$emit('global-search-keyword', query.keyword)
    },
  },
}
</script>

<style>
html, body {
  font-size: 14px;
}
body {
  margin-bottom: 3rem;
}
a {
  cursor: pointer;
}
section.container {
  margin-top: 5rem;
}
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  padding: .5rem 1rem;
  border-top: 1px #ccc solid;
  background-color: #f5f5f5;
  font-size: .9rem;
  line-height: 1em;
  z-index: 1;
}
</style>
